import { Chip, Tooltip, type ChipProps } from '@mui/material';
import type { AdminAssignmentStatus } from '../../../api/adminConsole';
import {
  effectiveAssignmentStatus,
  formatAssignmentExpiry,
} from '../../../lib/iamAssignmentStatus';

/**
 * One role on a user. Expiring roles are amber with the expiry in the tooltip; expired roles are
 * struck through (they grant nothing and are not counted).
 */
export function RoleAssignmentChip({
  name,
  status,
  expiresAt,
  onDelete,
  size = 'small',
}: {
  name: string;
  status?: AdminAssignmentStatus;
  expiresAt?: string | null;
  onDelete?: ChipProps['onDelete'];
  size?: ChipProps['size'];
}) {
  const effective = effectiveAssignmentStatus({ status, expiresAt });
  const tooltip = expiresAt ? formatAssignmentExpiry(expiresAt) : 'No expiry';
  const chip = (
    <Chip
      label={name}
      size={size}
      variant={effective === 'active' ? 'filled' : 'outlined'}
      color={effective === 'expiring' ? 'warning' : 'default'}
      onDelete={onDelete}
      sx={
        effective === 'expired'
          ? { textDecoration: 'line-through', opacity: 0.6 }
          : undefined
      }
    />
  );
  return (
    <Tooltip title={effective === 'expired' ? `${tooltip} — not counted` : tooltip}>
      <span>{chip}</span>
    </Tooltip>
  );
}
